export default function getEnv(name: string): string {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return window?.runtimeConfig?.[name] || process.env[name];
}
